module.exports = __webpack_public_path__ + "static/media/xlsx_icon.1d4483fe.svg";